import styled from 'styled-components';
import React from 'react';
import Colors from 'enums/Colors';
import { ButtonHomeV2 } from '../button/ButtonHomeV2.styled';

const StyleSupport = {
    Container: styled.section`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 56px;

        background: ${Colors.White};

        @media (max-width: 768px) {
            flex-direction: column;
            align-items: flex-start;
            padding: 32px 20px 40px;
            gap: 16px;
        }
    `,

    ImageContainer: styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
    `,

    Image: styled.img`
        width: 320px;
        max-width: 100%;
        height: auto;

        @media (max-width: 768px) {
            width: 220px;
            height: auto;
        }
    `,

    Content: styled.div`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 32px;
        max-width: 430px;

        @media (max-width: 768px) {
            width: 100%;
            align-items: flex-start;
            gap: 20px;
        }
    `,

    Title: styled.h1`
        font-family: 'Barlow';
        font-size: 32px;
        font-weight: 700;
        line-height: 100%;
        color: ${Colors.Blue};

        @media (max-width: 768px) {
            font-size: 22px;
            line-height: 100%;
            max-width: 260px;
        }
    `,

    Description: styled.h2`
        font-family: 'Barlow';
        font-size: 16px;
        font-weight: 400;
        line-height: 150%;
        color: ${Colors.Blue};

        @media (max-width: 768px) {
            max-width: 280px;
        }
    `,
};

export default StyleSupport;
